<template>
    
</template>
<script>
    export default {
        computed: {
            colorFilter() {
                return this.filter;
            }
        },
        methods: {
            updateFilter() {
                this.colorFilter.checked = !this.colorFilter.checked;
//                this.$set(this.colorFilter, 'checked', !this.colorFilter.checked);
                this.$forceUpdate();
                // Inform parent about this
                this.$emit('filter-updated', this.colorFilter);
            }
        },
        props: ['filter']
    }
</script>
